module.exports = __webpack_public_path__ + "img/h zwaardecrstr voor.f064ec0e.jpg";